import { ABILTYPE } from "../gamedata/chartypes";
import { getStoreItems, getStoreTabName } from "../datamanagers/storedatamanager";
import { StateManager } from "../states/statemanager";

global.VAR_INDEX = {
  SEX: 0,
  BIRTH: 1,
  CLASS: 2,
  UNION: 3,
  RANK: 4,
  FAME: 5,
  STR: 6,
  DEX: 7,
  INT: 8,
  CON: 9,
  CHA: 10,
  SEN: 11,
  EXP: 12,
  LEVEL: 13,
  POINT: 14
};

export const GF: any = {};

GF.getVariable = (type: any) => {
  let value = -1;

  switch(type) {
  case VAR_INDEX.SEX:
    value = MC.getAbilityValue(ABILTYPE.SEX);
    break;
  case VAR_INDEX.BIRTH:
    value = MC.getAbilityValue(ABILTYPE.BIRTH);
    break;
  case VAR_INDEX.CLASS:
    value = MC.getAbilityValue(ABILTYPE.CLASS);
    break;
  case VAR_INDEX.UNION:
    value = MC.getAbilityValue(ABILTYPE.UNION);
    break;
  case VAR_INDEX.RANK:
    value = MC.getAbilityValue(ABILTYPE.RANK);
    break;
  case VAR_INDEX.FAME:
    value = MC.getAbilityValue(ABILTYPE.FAME);
    break;
  case VAR_INDEX.STR:
    value = MC.getAbilityValue(ABILTYPE.STR);
    break;
  case VAR_INDEX.DEX:
    value = MC.getAbilityValue(ABILTYPE.DEX);
    break;
  case VAR_INDEX.INT:
    value = MC.getAbilityValue(ABILTYPE.INT);
    break;
  case VAR_INDEX.CON:
    value = MC.getAbilityValue(ABILTYPE.CON);
    break;
  case VAR_INDEX.CHA:
    value = MC.getAbilityValue(ABILTYPE.CHA);
    break;
  case VAR_INDEX.SEN:
    value = MC.getAbilityValue(ABILTYPE.SEN);
    break;
  case VAR_INDEX.EXP:
    value = MC.getAbilityValue(ABILTYPE.EXP);
    break;
  case VAR_INDEX.LEVEL:
    value = MC.getAbilityValue(ABILTYPE.LEVEL);
    break;
  }

  return [ value ];
};

GF.getName = () => {
  return [ MC.name ];
};

GF.getReviveZoneName = () => {
  const listZones = GDM.getNow('list_zone');
  const zoneNames = GDM.getNow('zone_names');
  const zoneStrKey = listZones.item(MC.reviveZoneNo, 26);
  const name = zoneNames.getByKey(zoneStrKey).text;
  return [ name ];
};

GF.setRevivePosition = () => {
  netGame.setRevivePosition();
  MC.reviveZoneNo = MC.zoneNo;
  return [ 0 ];
};

// AT_store's Lua calls this as GF_openStore(iObject, specialFlag) --
// iObject is the NPC's serverObjectIdx (from QF_getEventOwner), specialFlag
// toggles whether the NPC's 4th ("special") LIST_NPC.STB tab is shown.
GF.openStore = (iObject: any, specialFlag: any) => {
  const npcObj = GZM.findByServerObjectIdx(iObject);
  if (!npcObj || !npcObj.stats) {
    return [0];
  }

  const tabIds = npcObj.stats.getStoreTabs();
  const tabIdsToShow = specialFlag ? tabIds : tabIds.slice(0, 3);

  const itemData = GDM.getNow("item_data");
  const tabs: { name: string; items: any[] }[] = [];
  for (const tabId of tabIdsToShow) {
    if (!tabId) {
      continue;
    }
    const items: any[] = [];
    for (const { itemType, itemNo } of getStoreItems(tabId)) {
      const price = itemData.getBuyPrice(itemType, itemNo);
      if (price === null) {
        continue;
      }
      items.push({
        itemType,
        itemNo,
        name: itemData.getName(itemType, itemNo),
        price,
      });
    }
    if (items.length) {
      tabs.push({ name: getStoreTabName(tabId), items });
    }
  }

  StateManager.get("game").gameUI.npcStore.open(npcObj, tabs);
  return [1];
};

export {};
